import {
  SearchApiModel,
  useAxios,
  useDeleteNulls,
} from "@sttedra_ui/framework";

import MapTypesApiResponseModel from "./map-types.api-response-model.js";

// #region Globals
const { base } = useAxios();
const timeout = 5000;
// #endregion

// #region Public functions
async function mapTypesListAll(searchParams = {}) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = `/MapType/mapType/listAll`;

    const response = await base.get(url, searchModel, {
      timeout,
    });

    const data = response.data.map((u) => new MapTypesApiResponseModel(u));

    return data;
  } catch (err) {
    localStorage.setItem("errorToastMessage", "Error al buscar los registros");

    return err;
  }
}
// #endregion

// #region Private functions
// #endregion

export { mapTypesListAll };
